module.exports = ".div-space {\r\n  padding-top: 20px;\r\n}\r\n\r\n.border-spacing {\r\n  border-bottom: 1px dashed lightgrey;\r\n  padding-bottom: 15px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tryout/pages/tryout-members/partial/tryout-set-questions/tryout-set-questions.component.css
// module id = ./src/app/tryout/pages/tryout-members/partial/tryout-set-questions/tryout-set-questions.component.css
// module chunks = main